<!--
Modal component with customizable slots and CSS transitions.
-->

<script>
import addPvFieldsModal from './addPvFieldsGMapModalContent.vue'

export default {
  name: 'addPvFieldsButtonAndModal',
  components: {
    addPvFieldsModal
  },
  props: ['zone','parametre','nameproject','name','appurl','routesubmit','mode','champs','pvfields','site'],
  data() {
    return {
      showModal: false,
      Mode:this.mode,
      title:"",
      icon:"",
      button:"",
      buttonTxt:"",
    }
  },
  mounted(){
    //affectation du type d'icon, du titre et du text en fonction du mode
    this.icon=this.Mode==="add"?"glyphicon glyphicon-plus":"glyphicon glyphicon-pencil";
    this.title=this.Mode==="add"? trans.get('common.add'):trans.get('common.edit'); ;
    this.buttonTxt=this.Mode==="add"? trans.get('common.new'):"";
  },
  methods: {
    afficheModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    }
  }
}
</script>

<template>
  <div>
    <div>                                  
      <a id="show-modal" class="buttonOriginal d-inline" aria-label="right Align" :title="this.title" @click="afficheModal">                 
        <span :class="this.icon" :title="this.title"></span>
        <label v-if="this.Mode=='add'" for="show-modal"><h6>{{this.buttonTxt}}</h6></label>
      </a> 
    </div>
    <div>
      <!-- use the modal component, pass in the prop -->
      <addPvFieldsModal v-if="showModal" @close="closeModal" :zone="this.zone" :parametre="this.parametre" :nameproject="this.nameproject" :name="this.name"  :appurl="this.appurl" :routesubmit="this.routesubmit" :champs="this.champs" :pvfields="this.pvfields" :site="this.site" :mode="this.mode"></addPvFieldsModal>
    </div>
  </div>
</template>